import { Loader2 } from 'lucide-react'

export function FullPageSpinner({ label }: { label?: string }) {
  return (
    <div
      className="flex min-h-dvh flex-col items-center justify-center gap-3 bg-surface-page"
      role="status"
      aria-live="polite"
    >
      <Loader2 className="size-6 animate-spin text-accent-strong" aria-hidden />
      <span className="text-xs text-content-secondary">{label ?? 'Loading…'}</span>
    </div>
  )
}
